// ---------------------------------------------- modules import
import { IPostState, PostAction, PostActionType } from "./common";

const initialState: IPostState = {
  loading: false,
  error: null
};

// ---------------------------------------------- the reducer
const postReducer = (state = initialState, action: PostAction): IPostState => {
  switch (action.type) {
    case PostActionType.ADD_POST_BEGIN:
    case PostActionType.PIN_POST_BEGIN:
    case PostActionType.UPDATE_POST_BEGIN:
    case PostActionType.DELETE_POST_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case PostActionType.ADD_POST_SUCCESS:
    case PostActionType.PIN_POST_SUCCESS:
    case PostActionType.UPDATE_POST_SUCCESS:
    case PostActionType.DELETE_POST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case PostActionType.ADD_POST_ERROR:
    case PostActionType.PIN_POST_ERROR:
    case PostActionType.UPDATE_POST_ERROR:
    case PostActionType.DELETE_POST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};

export default postReducer;
